import AnnouncementIcon from "./AnnouncementIcon.mjs";

const AvvisiIcon = class extends AnnouncementIcon {}

export default AvvisiIcon;
